import Vue from 'vue'
import Router from 'vue-router'
// page components without props
import index from '@/components/index/index.vue'
import projects from '@/components/projects/projects.vue'
import news from '@/components/news/news.vue'
import services from '@/components/services/services.vue'
import contact from '@/components/contact/contact.vue'
import impressum from '@/components/impressum/impressum.vue'

import privacy from '@/components/privacy/privacy.vue'
// page components with props
import project from '@/components/projects/project/project.vue'
import newsArticle from '@/components/news/news-article/news-article.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: projects
    },
    {
      path: '/project',
      name: 'project',
      component: index
    },
    {
      path: '/leistungen',
      name: 'services',
      component: services
    },
    // {
    //   path: '/projects/:slug',
    //   name: 'project',
    //   component: project
    // },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/news/:slug',
      name: 'news-article',
      component: newsArticle
    },
    // {
    //   path: '/',
    //   name: 'services',
    //   component: services
    // },
    {
      path: '/kontakt',
      name: 'contact',
      component: contact
    },
    {
      path: '/datenschutz',
      name: 'privacy',
      component: privacy
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: impressum
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js